/**
 * Interface para a resposta de detalhes de lugares do Google Maps
 */
export type IPlaceDetailsResponse = {
  formattedAddress: string; // Endereço formatado do lugar
  location: {
    latitude: number; // Latitude do lugar
    longitude: number; // Longitude do lugar
  }; // Localização do lugar
  place_id: string; // ID único do lugar
  addressComponents: Array<AddressComponentPlaceDetails>; // Componentes do endereço
}

interface AddressComponentPlaceDetails {
  longText: string; // Texto longo do componente
  shortText: string; // Texto curto do componente
  types: string[]; // Tipos do componente (route, locality, political, etc.)
  languageCode: string; // Código do idioma
}
